import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Cookies from "js-cookie";
import Landingheader from "./Landing/Landingheader";
import ScrollToTop from "./ScrollToTop";
const Partners = () => {
  const client_token = Cookies.get('user_token');
  const admin_token = Cookies.get('Admin_token');
  const [is_logged_in,setIs_logged_in] = useState(false);
  
    useEffect(() => {
      if(client_token || admin_token){
        setIs_logged_in(true);
      }else{
      setIs_logged_in(false);
      }
    },[client_token,admin_token])
  
  // Mock array for your business partners. Replace placeholder logos with actual images.
  const partnerList = [
    { id: 1, name: "Apex Construction Group", role: "Infrastructure & Dev", logo: "/images/partners/apex.jpg" },
    { id: 2, name: "Horizon Real Estate", role: "Land Brokerage Affiliate", logo: "/images/partners/horizon.jpg" },
    { id: 3, name: "Summit Urban Planning", role: "Municipal Consultations", logo: "/images/partners/summit.jpg" },
    { id: 4, name: "Terra Engineering", role: "Geotechnical Alliances", logo: "/images/partners/terra.jpg" },
    { id: 5, name: "Legacy Custom Homes", role: "Residential Development", logo: "/images/partners/legacy.jpg" },
    { id: 6, name: "Atlas GeoData Systems", role: "GIS & Mapping Technologies", logo: "/images/partners/atlas.jpg" },
  ];

  return (
    <>
     { is_logged_in ? (<><Landingheader /></>) : (<><Header /></>)}
    <div className="min-h-screen bg-slate-50 text-slate-800">

      {/* Hero Header Section */}
      <ScrollToTop />
      <div className="px-4 py-16 text-center border-b bg-slate-100 border-slate-200">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-[#1A3D6D]">
          Our Enterprise Partners
        </h1>
        <p className="max-w-xl mx-auto mt-3 text-sm font-medium text-slate-600 md:text-base">
          Collaborating with leading construction, architectural, and municipal entities to deliver accurate spatial boundaries.
        </p>
      </div>

      <div className="max-w-5xl px-4 py-12 mx-auto">
        
        {/* Intro Pitch */}
        <div className="mb-12 text-center">
          <h2 className="text-xl md:text-2xl font-bold text-[#1A3D6D] mb-2">Building Better Landscapes Together</h2>
          <p className="max-w-2xl mx-auto text-sm text-slate-600">
            Through secure data integrations and prioritized site schedules, we ensure our strategic partners receive pristine survey configurations to hit their project deadlines flawlessly.
          </p>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-2 gap-6 mb-16 md:grid-cols-3">
          {partnerList.map((partner) => (
            <div 
              key={partner.id} 
              className="flex flex-col items-center justify-center p-6 transition-all bg-white border shadow-sm border-slate-200 rounded-xl hover:shadow-md group"
            >
              {/* Logo Box Placeholder */}
              <div className="w-24 h-24 bg-slate-100 rounded-full flex items-center justify-center mb-4 border border-slate-100 group-hover:bg-[#1A3D6D]/5 transition-colors overflow-hidden">
                {/* Fallback layout if specific partner images are missing */}
                <img 
                  src={partner.logo} 
                  onError={(e) => { e.target.src = "https://via.placeholder.com/150?text=Logo" }}
                  className="object-cover w-full h-full p-2" 
                  alt={partner.name} 
                />
              </div>
              <h3 className="font-bold text-slate-800 text-center text-sm md:text-base group-hover:text-[#1A3D6D] transition-colors">
                {partner.name}
              </h3>
              <p className="mt-1 text-xs font-medium text-slate-500">
                {partner.role}
              </p>
            </div>
          ))}
        </div>

        {/* Call to Action Banner */}
        <div className="bg-[#1A3D6D] rounded-2xl text-white p-8 md:p-12 text-center shadow-lg relative overflow-hidden">
          {/* Subtle design layer background ring */}
          <div className="absolute w-40 h-40 rounded-full pointer-events-none -right-10 -bottom-10 bg-white/5" />
          
          <h2 className="text-2xl md:text-3xl font-bold mb-3 text-[#C9FAC8]">
            Become an Authorized Partner
          </h2>
          <p className="max-w-xl mx-auto mb-6 text-sm text-slate-200">
            Are you an architectural firm, infrastructure developer, or legal real estate agency? Partner with New World Surveyor for dedicated scheduling pipelines and bulk service rates.
          </p>
          <Link 
            to="/contact" 
            className="inline-block bg-[#FF9800] hover:bg-[#FF9800]/90 text-white font-bold py-3 px-8 rounded-xl transition-all transform hover:-translate-y-0.5 shadow-md"
          >
            Join Our Network
          </Link>
        </div>

      </div>
    </div>
    <Footer />
    </>
  );
};

export default Partners;